<template>
  <b-img src="@/assets/logos/bling-logo.png" width="300"></b-img>
</template>

<script>
import { BImg } from 'bootstrap-vue'
export default {
  name: 'LogoBling',
  components: {
    BImg,
  },
}

</script>

<style scoped>
  svg {
    width: 100%;
  }
</style>
